module.exports = __webpack_public_path__ + "static/media/icon-arrow-up.b380d955.svg";